module.exports = __webpack_public_path__ + "static/media/plan-mas-250gb-wom71.1cd37455.svg";